import { gql } from '@apollo/client';
const UPDATE_MODEL_SPECIFICATION_STATUS = gql `
  mutation UpdateModelSpecificationStatus(
    $statusId: ID!
    $namePL: String
    $nameEN: String
    $color: ModelSpecificationStatusColor
  ) {
    updateModelSpecificationStatus(
      statusId: $statusId
      namePL: $namePL
      nameEN: $nameEN
      color: $color
    ) {
      status {
        id
        namePL
        nameEN
        color
        canBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default UPDATE_MODEL_SPECIFICATION_STATUS;
